import { useState } from 'react';
import { Card, Upload, Button, Typography, Input, Space, message } from 'antd';
import { DownloadOutlined, UploadOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { useClients } from '../../context/ClientContext';

const { TextArea } = Input;

const JsonConfigTool = () => {
  const [rawJson, setRawJson] = useState<string>('');
  const [transformed, setTransformed] = useState<string>('');
  const { activeClient } = useClients();

  const handleFile = (file: File) => {
    const reader = new FileReader();
    reader.onload = () => {
      setRawJson(reader.result as string);
    };
    reader.readAsText(file);
    return false; // prevent auto upload
  };

  const mockTransform = () => {
    try {
      const obj = JSON.parse(rawJson || '{}');
      const enriched = {
        client: activeClient?.name || 'Unknown',
        policyVersion: activeClient?.policyVersion,
        transformedAt: new Date().toISOString(),
        originalKeys: Object.keys(obj),
        original: obj,
      };
      setTransformed(JSON.stringify(enriched, null, 2));
      message.success('Transformation complete (mock).');
    } catch (e) {
      message.error('Invalid JSON');
    }
  };

  const download = () => {
    const blob = new Blob([transformed], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = 'transformed.json';
    a.click();
  };

  return (
    <Card title="JSON Configuration Tool" className="!bg-[#1F2937] !border !border-solid !border-[#414756]" classNames={{ header: '!text-white', body: '!text-white' }}>
      <Typography.Paragraph className="!text-[#9ca3af]">Paste or upload a JSON configuration to apply client-specific policy enrichment (mock).</Typography.Paragraph>
      <Space direction="vertical" className="!w-full" size="middle">
        <Upload beforeUpload={handleFile} showUploadList={false}> <Button icon={<UploadOutlined />}>Upload JSON</Button> </Upload>
        <TextArea rows={8} value={rawJson} placeholder="Paste JSON here" onChange={e=>setRawJson(e.target.value)} />
        <Button type="primary" icon={<PlayCircleOutlined />} onClick={mockTransform} disabled={!rawJson.trim()}>Transform</Button>
        <TextArea rows={8} value={transformed} placeholder="Transformed JSON" onChange={e=>setTransformed(e.target.value)} />
        <Button icon={<DownloadOutlined />} disabled={!transformed} onClick={download}>Download</Button>
      </Space>
    </Card>
  );
};
export default JsonConfigTool;
